export default __webpack_public_path__ + "static/media/1.blur.42894f58.jpg";